<template>
	<v-dialog v-model="resultDialogVisible" width="600">
    <customDialog>
      <template v-slot:title>
        {{'グループを選択してください'}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="resultDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
						<v-row class="ma-0 pa-0 mt-2 mb-14">
              <v-col id="store_list" class="ma-0 pa-0" cols="12" align="left">
								<v-col class="ma-0 pa-0" cols="12"
									v-for="(item, index) in msgList" :key="index">
									{{item}}
								</v-col>
							</v-col>
            </v-row>
						<v-row class="ma-0 pa-0" align="center" justify="center">
							<v-btn width="8rem" height="auto" class="ma-0 pa-2" 
								id="blue_btn" elevation="0" @click="resultDialogVisible = false">
									{{'OK'}}
							</v-btn>
						</v-row>
          </v-col> 
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
		msgList: Array,
	},
	components: {
		CustomDialog
	},
	mixins: [mixin.common],
	data: () => ({
		resultDialogVisible: false,
	}),
	watch: {
    dialogVisible: function(item) {
      this.resultDialogVisible = item;
    },
    resultDialogVisible: function(item) {
      this.$emit('visible', item);
			if(item) {
				console.log(this.msgList);
			}
    },
  },
	methods: {
		
	},
}
</script>

<style lang="scss" scoped>
#store_list {
  border-radius: 3px;
  width: 100%;
  min-height: 350px;
	max-height: 350px;
	overflow: auto;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
</style>